import { MarketName } from "types/markets";
import { IndustryMovementOption, CategoryFinConstr } from "types/addScenario";

export const optTargetElements = [
  { value: "cpg_revenue", label: "Net Sales" },
  { value: "cpg_profit", label: "Gross Profit" },
  { value: "cpg_volume", label: "Volume" },
  { value: "cpg_market_share", label: "Market Share" },
];

export const industryMovementOptions: Record<MarketName, IndustryMovementOption[]> = {
  [MarketName.FLUS]: [
    { value: "Industry moves 100%", label: "Industry moves 100%", testId: "industry-moves-100" },
    { value: "Industry moves 50%", label: "Industry moves 50%", testId: "industry-moves-50" },
    { value: "No movement", label: "No movement", testId: "no-movement" },
  ],
  [MarketName.PMF]: [
    { value: "Yes", label: "Yes", testId: "industry-moves-yes" },
    { value: "No", label: "No", testId: "industry-moves-no" },
  ],
  [MarketName.UK]: [],
};

export const commonIndustryMovementOpts: IndustryMovementOption[] = [
  { value: "Yes", label: "Yes", testId: "industry-moves-yes" },
  { value: "No", label: "No", testId: "industry-moves-no" },
];

export const categoryFinConstrDataFLUS: CategoryFinConstr[] = [
  {
    name: "minNetSales",
    label: "Min Net Sales ($)",
    isPercentage: true,
    //dependsOnOptTargetVal: "cpg_revenue",
    referenceValParam: "netSales",
  },
  {
    name: "maxNetSales",
    label: "Max Net Sales ($)",
    isPercentage: true,
    //dependsOnOptTargetVal: "cpg_revenue",
    referenceValParam: "netSales",
  },
  {
    name: "minGrossProfit",
    label: "Min Gross Profit ($)",
    isPercentage: true,
    //dependsOnOptTargetVal: "cpg_profit",
    referenceValParam: "grossProfit",
  },
  {
    name: "maxGrossProfit",
    label: "Max Gross Profit ($)",
    isPercentage: true,
    //dependsOnOptTargetVal: "cpg_profit",
    referenceValParam: "grossProfit",
  },
  {
    name: "minVolume",
    label: "wizardStep2_minVolume",
    isSpecLabel: true,
    isPercentage: true,
    //dependsOnOptTargetVal: "cpg_volume",
    referenceValParam: "volume",
  },
  {
    name: "maxVolume",
    label: "wizardStep2_maxVolume",
    isSpecLabel: true,
    isPercentage: true,
    //dependsOnOptTargetVal: "cpg_volume",
    referenceValParam: "volume",
  },
  {
    name: "minNetRevenue",
    label: "wizardStep2_minNetRevenue",
    isSpecLabel: true,
    isPercentage: true,
    referenceValParam: "minNetRevPerMktUnit",
  },
  {
    name: "maxNetRevenue",
    label: "wizardStep2_maxNetRevenue",
    isSpecLabel: true,
    isPercentage: true,
    referenceValParam: "minNetRevPerMktUnit",
  },
  {
    name: "minMarketShare",
    label: "Min Market Share (%)",
    isPercentage: true,
    //dependsOnOptTargetVal: "cpg_market_share",
    referenceValParam: "pepMktShr",
  },
  {
    name: "maxMarketShare",
    label: "Max Market Share (%)",
    isPercentage: true,
    //dependsOnOptTargetVal: "cpg_market_share",
    referenceValParam: "pepMktShr",
  },
];

export const categoryFinConstrDataPMF: CategoryFinConstr[] = [
  {
    name: "minNetSales",
    label: "Min Net Sales ($)",
    isPercentage: true,
    dependsOnOptTargetVal: "cpg_revenue",
    referenceValParam: "netSales",
  },
  {
    name: "minGrossProfit",
    label: "Min Gross Profit ($)",
    isPercentage: true,
    dependsOnOptTargetVal: "cpg_profit",
    referenceValParam: "grossProfit",
  },
  {
    name: "minVolume",
    label: "wizardStep2_minVolume",
    isSpecLabel: true,
    isPercentage: true,
    dependsOnOptTargetVal: "cpg_volume",
    referenceValParam: "volume",
  },
  {
    name: "minNetRevenue",
    label: "wizardStep2_minNetRevenue",
    isSpecLabel: true,
    isPercentage: true,
    referenceValParam: "minNetRevPerMktUnit",
  },
  {
    name: "maxNetRevenue",
    label: "wizardStep2_maxNetRevenue",
    isSpecLabel: true,
    isPercentage: true,
    referenceValParam: "minNetRevPerMktUnit",
  },
  {
    name: "minMarketShare",
    label: "Min Market Share (%)",
    isPercentage: true,
    dependsOnOptTargetVal: "cpg_market_share",
    referenceValParam: "pepMktShr",
  },
];

// Mapping of related min/max fields
export const minMaxPairs = {
  minNetSales: "maxNetSales",
  maxNetSales: "minNetSales",
  minGrossProfit: "maxGrossProfit",
  maxGrossProfit: "minGrossProfit",
  minVolume: "maxVolume",
  maxVolume: "minVolume",
  minNetRevenue: "maxNetRevenue",
  maxNetRevenue: "minNetRevenue",
  minMarketShare: "maxMarketShare",
  maxMarketShare: "minMarketShare",
};
